<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import NavBarHeader from 'components/Model/NavBarHeader.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body">
        <NavBarHeader
          :model="router.currentRoute.value.params.name"
          :banner="bannerAssineHorizontal"
        />
    </div>
  </MainLayout>
</template>
<script lang="ts">
  import modelTradutor from 'tradutors/model'
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import api from '../../api'
  import router from 'router'
  import { isMobile } from "../shared/utils/mobile";

  export default defineComponent({
    name: 'ModelView',
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return modelTradutor.portugues
        } else {
          return modelTradutor.ingles
        }
      }
    },
    watch: {
      'locale': function () {
        this.getBannerPath(true)
      }
    },
    data() {
      return {
        bannerAssineHorizontal: [],
        isMobile: isMobile(),        
      }
    },
    methods: {
      getBannerPath(changeLanguage = false) {
        if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
        api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
          this.bannerAssineHorizontal = data.bannerAssineHorizontal
          sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
        })
        else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
      }
    },
    mounted() {
      this.getBannerPath()
    },
    create() {
      const lang = ['pt-br', 'en']
      if (lang.indexOf(router.currentRoute.value.params.language) === -1) {
        window.location.replace('/')
      }
    }
  })
</script>
<style scoped lang="css">
  .slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
  }

  .title {
    font-family: 'Bebas-Neue-Light';
    font-size: 60px;
    font-weight: 500;
    color: black;
  }

  .title-models {
    font-family: 'Exo-2';
    font-size: 32px;
    font-weight: 600;
    color: #b20000;
  }

  .subtitle {
    font-size: 24px;
    font-weight: 600;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
  
  }
</style>
